import { MouseEvent } from 'react';

/** Every cell sits inside the row's link, so a button click must not also follow it. */
export function withoutRowNavigation(handler: () => void) {
  return function handleClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    handler();
  };
}
